import { createContext, useContext } from 'react';

export interface ScrollContextType {
  scrollToHeader: (id: string, level?: number) => void;
  setMenu: (menu: {
    open: boolean;
    x: number;
    y: number;
    header: { id: string; title: string; level: number } | null;
  }) => void;
}

export const ScrollContext = createContext<ScrollContextType>({
  scrollToHeader: () => {},
  setMenu: () => {},
});

export function useScrollContext() {
  return useContext(ScrollContext);
}
